<template>
    <div>
        <exchange-month 
            ref="list"
            header-text="月明細"
        >
            <div v-if="getListObj">
                <div class="card" v-if="getListObj.data.length > 0">
                        <ul class="list-group list-group-flush let-space-1">
                            <li class="list-group-item pb-1" v-for="item in getListObj.data" :key="item.id">
                                <div class="d-flex align-items-center">
                                    <span><i class="fas fa-donate text-primary icon-size"></i></span>
                                    <span class="flex-fill pl-3">
                                        <b>{{toLocaleString(item.points)}}</b><small>Pt</small>
                                    </span>
                                    <span v-if="item.status == '0'" class="badge badge-pill badge-warning py-1 px-1">依頼済</span>
                                    <span v-if="item.status == '1'" class="badge badge-pill badge-success py-1 px-1">処理中</span>
                                    <span v-if="item.status == '2'" class="badge badge-pill badge-secondary py-1 px-1">振込済</span>
                                    <!-- 処理中へ -->
                                    <span @click="payStatus(item,'1')" v-if="item.status == '0'"> <i class="fas fa-pause text-warning-cust pl-4"></i> </span>
                                    <!-- 処理完了へ -->
                                    <span @click="payStatus(item,'2')" v-if="item.status == '1'"> <i class="fas fa-play text-success pl-4"></i> </span>
                                    <span v-if="item.status == '2'"> <i class="fas fa-circle text-secondary pl-4"></i> </span>
                                </div>
                                <hr class="my-1">
                                <div @click="toPerson(item.user_id, item.name)">
                                    <div>
                                        <span><small>{{item.bank_nm}}</small></span>
                                        <span><small>({{item.branch_nm}})</small></span>
                                        <span><small>({{item.branch_id}}-{{item.account_id}})</small></span>
                                    </div>
                                    <div>
                                        <span><small>{{item.first_nm}}&nbsp;&nbsp;{{item.last_nm}}</small></span>
                                        <span><small>({{item.first_kana}}&nbsp;&nbsp;{{item.last_kana}})</small></span>
                                    </div>
                                    <div v-if="item.exchange_rate_at">
                                        <span><small><b>{{toLocaleString(toNum(item.exchange_rate_at) * item.points)}}円&nbsp;({{item.exchange_rate_at}})</b></small></span>
                                        <span>/</span>
                                        <span class="text-success"><small><b>({{item.now_rate}})</b></small></span>
                                    </div>
                                    <div v-else>
                                        <span><small><b>{{toLocaleString(toNum(item.now_rate) * item.points)}}円&nbsp;</b></small></span>
                                        <span class="text-success"><small><b>({{item.now_rate}})</b></small></span>
                                    </div>
                                </div>
                                <div class="text-right text-muted">
                                    <small><small>{{item.created_at | dformatm}}</small></small>
                                </div>
                            </li>
                        </ul>
                    </div>
            </div>
        </exchange-month>
        
        <!-- メッセージ -->
        <info-msg ref="msg" :lev="lev" :msg="msg" @ok="msgOk"></info-msg>
    </div>
</template>

<script>
    import ExchangeMonth from 'pages/commons/List/List'
    import InfoMsg from 'pages/commons/modal/infoMsg/InfoMsg'

    import {mapGetters} from 'vuex'

    export default {
        components: {
            ExchangeMonth,
            InfoMsg
        },
        data () {
            return {
                lev: 0,
                msg: "",
                exItem: "",
                exStatus: ""
            }
        },
        created () {
            this.$store.dispatch('setListObjKeep')
        },
        mounted () {
            this.$refs.list.loadListObj({
                url: 'invite.point.exchange.month',
                data: this.$route.params.month
            })
            this.$refs.list.resetRefresh('exchangeMonth')
        },
        activated () {
            this.$refs.list.isGetListChild('exchangeMonth', {
                url: 'invite.point.exchange.month',
                data: this.$route.params.month
            })
            this.$refs.list.resetRefresh('exchangeMonth')
        },
        watch: {
            getPayStatusChangeStatus (status) {
                if (status == 0) {
                    this.$store.dispatch('startSpinner')
                }
                if (status == 2) {
                    this.$store.dispatch('reflectList', this.getPayStatusChangeItem.data)
                    this.$store.dispatch('doneSpinner')
                }
                if (status == 3) {
                    this.$store.dispatch('doneSpinner')
                }
            },
        },
        computed: {
            ...mapGetters(['getListObj'
                ,'getPayStatusChangeItem'
                ,'getPayStatusChangeStatus'
            ])
        },
        methods: {
            toPerson (userId, name) {
                this.$router.push({name:'TechDetail', params:{
                    userId: userId,
                    name: name
                }})
            },
            payStatus (item, status) {
                this.exItem = item
                this.exStatus = status
                let msg = status == '1' ? '処理開始しますか？' : '完了通知を送信しますか？'
                this.openMsg(2, msg)
            },
            payStatusDo () {
                this.$store.dispatch('payStatus',{
                    item: this.exItem,
                    status: this.exStatus
                })
            },
            openMsg (lev, msg, key) {
                this.lev = lev
                this.msg = msg
                this.$refs.msg.openThis()
            },
            msgOk () {
                this.payStatusDo()
            },
            toLocaleString (num) {
                return Number(num).toLocaleString()
            },
            toNum (val) {
                return Number(val)
            }
            

        }
    }
</script>
